import React, { Fragment, useEffect, useState } from "react";
import { getAllClients } from "../../services/clients/clients";
import {
  Alert,
  Badge,
  // Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Input,
  Row,
  Table,
} from "reactstrap";
import {
  GetInvoicePpd,
  getPayForms,
  sendStampComplement,
  GetSettingsInvoice
} from "../../services/invoice/invoice";
import { validarSesion } from "../../hooks/tokens/useToken";
import { useSweetAlert } from "../../hooks/sweetAlerts/useSweetAlert";
import { useHistory, useParams } from "react-router-dom";
import FormatNumbers, { FormatAmount } from "../../utils/formatNumbers";
import { ModalComplementPayment } from "../../components/Invoice/ModalComplementPayment";
import { getAllCommercialLines } from "../../services/commercialLine/commercialLine";
import TypePersonInvoiceEnum from "../../utils/enum/type_person.enum";
import { getAllBranches } from "../../services/commercialLine/commercialLine";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';



export const IndexComplementPaymentService = () => {
  const history = useHistory();
  const { idCompany, idInvoice } = useParams();
  console.log("🚀 ~ IndexComplementPaymentService ~ idInvoice:", idInvoice)
  console.log("🚀 ~ IndexComplementPaymentService ~ company:", idCompany)
  const [createSweet] = useSweetAlert();

  const branchId = localStorage.getItem("branchId");

  const [listCommercialLines, setListCommercialLines] = useState([]);
  const [listClients, setListClients] = useState([]);
  const [isSelectedClients, setIsSelectedClients] = useState(false);
  const [clientInformation, setClientInformation] = useState(null);
  const [listInvoices, setListInvoices] = useState([]);
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [listPayForms, setListPayForms] = useState([]);

  const [loadingComplement, setLoadingComplement] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [disableBtnSave, setDisableBtnSave] = useState(false);
  const [isPreComplement, setIsPreComplement] = useState(false);

  const [globalFilter, setGlobalFilter] = useState(null);
  const [expandedRows, setExpandedRows] = useState(null);
  const [datECurrentTime, setDatECurrentTime] = useState('');
  const [showPreview, setShowPreview] = useState(false);
  console.log("🚀 ~ IndexComplementPaymentService ~ showPreview:", showPreview)

  const [formComplement, setFormComplement] = useState({
    commercialLineId: "",
    companyBusinessNameId: "",
    taxRegimeId: "",
    type_person: "",
    paymentDate: "",
    paymentFormId: "",
    comments: "",
  });

  useEffect(() => {
    GetAllClients();
    GetPayForms();
    GetCommercialLines();
  }, []);

  const GetAllClients = async () => {
    const listClient = await getAllClients();

    if (listClient) {
      setListClients(listClient);
    }
  };

  const GetCommercialLines = async () => {
    const commercialLines = await getAllCommercialLines();
    const branches = await getAllBranches();

    const branch = branches.find(x => x.id_branch === parseInt(branchId)) ?? {};

    const _cp = branch.cp ?? null;
    const _colony = branch.colony ?? '';
    const _address = branch.address ?? '';


    if (commercialLines?.length > 0) {
      const list = commercialLines?.map((commercial) => {
        return {
          value: commercial?.id_commercial_line,
          label: commercial?.long_name,
          rfc: commercial?.rfc,
          cp: commercial?.cp,
          cpBranch: _cp,
          colony: _colony,
          address: _address,
          id_tax_regime: commercial?.id_tax_regime,
          code_tax_regime: commercial?.code_tax_regime,
          name_tax_regime: commercial?.name_tax_regime,
          type_person: commercial?.type_person
            ? TypePersonInvoiceEnum.MORAL
            : TypePersonInvoiceEnum.FISICA,
        };
      });

      setListCommercialLines(list);
    } else setListCommercialLines([]);
  };


  const GetPayForms = async () => {
    const payForms = await getPayForms();

    if (payForms?.length > 0) {
      const list = payForms?.map((form) => {
        return {
          label: form.abbreviation + " - " + form.name,
          value: form.id_pay_method,
          code: form.abbreviation,
        };
      });

      setListPayForms(list);
    } else setListPayForms([]);
  };

  const GetRelatedinvoices = async (ClientId) => {
    const getListInvoices = await GetInvoicePpd(ClientId);

    if (getListInvoices?.code === 200) {
      if (getListInvoices?.data?.length > 0)
        setListInvoices(getListInvoices?.data);
    } else if (getListInvoices?.code === 401) {
      validarSesion(history, getListInvoices.code, GetRelatedinvoices);
    } else if (getListInvoices?.code === 500) {
      createSweet(
        "warning",
        "warning",
        "Obtener información del paciente",
        "Ocurrio un problema al obtener la información del paciente"
      );
    } else {
      createSweet("warning", "warning", "Orden", getListInvoices.msg);
    }
  };

  const handleCheckInvoice = (isSelected, invoice) => {
    if (isSelected) {
      setSelectedInvoices([
        ...selectedInvoices,
        {
          ...invoice,
          paymentBy: "liquided",
          amount: 0,
        },
      ]);
    } else {
      setSelectedInvoices(
        selectedInvoices.filter(
          (item) => item.id_invoice !== invoice.id_invoice
        )
      );
    }
  };

  const handleModal = (_pre) => {
    console.log("🚀 ~ handleModal ~ _pre:", _pre)
    setShowModal(!showModal);
    GetSettings(_pre)

  }

  const handleChangeType = (type, invoiceId) => {
    setSelectedInvoices(
      selectedInvoices.map((item) => {
        if (item.id_invoice === invoiceId) {
          return {
            ...item,
            paymentBy: type,
          };
        }
        return item;
      })
    );
  };

  const handleChangeAmount = (amount, invoiceId) => {
    setSelectedInvoices(
      selectedInvoices.map((item) => {
        if (item.id_invoice === invoiceId) {
          return {
            ...item,
            amount: amount,
          };
        }
        return item;
      })
    );
  };

  const handleSaveComplement = async () => {
    setLoadingComplement(true);
    setDisableBtnSave(true);


    console.log("entras");

    let errorInComplement = false;

    const body = {
      CommercialLineId: formComplement.commercialLineId,
      BranchId: branchId,
      ClientId: clientInformation?.id_company,
      ClientBusinessId: formComplement.companyBusinessNameId,
      PaymentDate: formComplement.paymentDate,
      PaymentFormCode: formComplement.paymentFormId,
      AdditionalComments: formComplement.comments,
      RelatedDocuments: selectedInvoices.map((invoice) => {

        const totalOfInvoice = invoice.total || 0;
        const totalDevolutions = invoice.total_devolutions || 0;
        const totalPaid = invoice.payment_amount || 0;

        let totalPreviousBalance = totalOfInvoice - totalDevolutions - totalPaid;
        totalPreviousBalance = FormatAmount(totalPreviousBalance, 2);

        let paidByUser = 0;
        let outsideBalance = 0;

        if (invoice.paymentBy !== "liquided") {
          paidByUser = invoice.amount || 0;
          paidByUser = isNaN(paidByUser + 1) ? 0 : parseFloat(paidByUser);

          if (paidByUser > totalPreviousBalance)
            errorInComplement = true;
          else if (paidByUser <= 0)
            errorInComplement = true;
        }

        if (invoice.paymentBy === "liquided") {
          paidByUser = totalPreviousBalance || 0;
          outsideBalance = 0;
        }
        else {
          outsideBalance = totalPreviousBalance - paidByUser;
          if (outsideBalance < 0) {
            outsideBalance = 0; // Ensure outside balance is not negative
          }
          outsideBalance = FormatAmount(outsideBalance, 2);
        }

        return {
          InvoiceId: invoice.id_invoice,
          PreviousAmount: totalPreviousBalance,
          PaymentAmount: paidByUser,
          OutsideBalance: outsideBalance,
          Partiality: invoice.parciality_number,
        };
      }),
      IsPreview: isPreComplement,
    };

    console.log("🚀 ~ handleSaveComplement ~ body:", body)


    if (errorInComplement) {
      createSweet(
        "error",
        "error",
        "Complemento de pago",
        "El monto pagado no puede ser mayor al saldo pendiente y no puede ser menor o igual a cero."
      );

      setLoadingComplement(false);
      setDisableBtnSave(false);

      return;
    }






    const sendStamp = await sendStampComplement(body);

    if (sendStamp.code === 200) {
      createSweet(
        "create",
        "info",
        "Exito!",
        "Se genero la factura con exito!"
      );

      setDisableBtnSave(false);
      setIsPreComplement(false);

      setTimeout(() => {
        window.location.href = "../../../facturacion/Emitidos";
      }, 2000);
    } else if (sendStamp.code === 401) {
      // validarSesion(history, sendStamp.code, handleSaveComplement);
      createSweet(
        "error",
        "error",
        "Factura",
        "Su sesión ha expirado, por favor vuelva a iniciar sesión"
      );
    }
    else if (sendStamp.code === 500)
      createSweet(
        "error",
        "error",
        "Factura",
        "Se perdio la conexión, con el servidor"
      );
    else if (sendStamp.code === 400)
      createSweet(
        "error",
        "error",
        "Factura",
        "No se llevo acabo la operación"
      );
    else createSweet("warning", "warning", "Factura", sendStamp.msg);

    setLoadingComplement(false);

    setDisableBtnSave(false);
  };



  const rowExpansionTemplate = (data) => {
    const columnsPerRow = 5;
    const rows = [];
    for (let i = 0; i < data.length; i += columnsPerRow) {
      rows.push(data.slice(i, i + columnsPerRow));
    }
  }




  const actionBodyTemplate = (rowData) => {
    console.log("🚀 ~ actionBodyTemplate ~ rowData:", rowData)
    return (
      <Button
        // label="Generar"
        title="Generar complemento de pago"
        icon="pi pi-file-pdf"
        className="p-button-warning"
        style={{ fontSize: '11px', padding: '5px 8px', height: '20px', width: "18px" }}
        onClick={() => {
          setIsSelectedClients(true);
          GetRelatedinvoices(rowData?.id_company);
          setClientInformation(rowData);
        }}
      />
    );
  };

  // *

  useEffect(() => {
    const loadData = async () => {

      if (!idCompany) return;

      setIsSelectedClients(true);

      GetRelatedinvoices(idCompany);
      console.log("🚀 ~ loadData ~ idCompany:", idCompany)
      GetPayForms();
      GetCommercialLines();

      // 🔥 obtener clientes
      const clients = await getAllClients();
      console.log("🚀 ~ loadData ~ clients:", clients)

      // // 🔍 buscar empresa
      const companyFound = clients.find(
        c => String(c.id_company) === String(idCompany)
      );

      if (companyFound) {
        setClientInformation(companyFound);
      }
    };

    loadData();
  }, [idCompany]);



  useEffect(() => {
    if (showPreview) {
      const ahora = new Date();
      const dia = String(ahora.getDate()).padStart(2, '0');
      const mes = String(ahora.getMonth() + 1).padStart(2, '0');
      const anio = ahora.getFullYear();
      const hora = String(ahora.getHours()).padStart(2, '0');
      const minuto = String(ahora.getMinutes()).padStart(2, '0');
      const segundo = String(ahora.getSeconds()).padStart(2, '0');

      setDatECurrentTime(`${dia}-${mes}-${anio} ${hora}:${minuto}:${segundo}`);
    }
  }, [showPreview]);

  const [listSettings, setListSettings] = useState([])

  // ? CONFIGURATION SETTINGS
  const GetSettings = async (_pre) => {

    const settings = await GetSettingsInvoice(branchId, _pre, 2);

    if (settings?.data.length > 0) {
      const list = settings?.data.map((form) => {
        return {
          branch: form.branch,
          serie: form.serie,
        };
      });

      setListSettings(list);
    } else setListSettings([]);
  };


  // ? CONFIGURATION DATATABLE
  const headerStyle =
  {
    backgroundColor: "#1d5b83",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "11px",
    borderRight: "1px solid #fff",
    borderBottom: "2px solid #fff",
  };

  const cellStyle =
  {
    fontSize: "11px",
    padding: "5px",
    textAlign: "center",
    fontFamily: "Montserrat, sans-serif",
  };






  const creditDaysMap = {
    0: 0,
    1: 0,
    2: 2,
    3: 7,
    4: 8,
    5: 9,
    6: 15,
    7: 30,
    8: 45,
    9: 60,
    10: 90
  };

  const renderCreditDays = (rowData) => {
    const days = creditDaysMap[rowData.credit_days] ?? 0;

    const severity =
      days === 0 ? "danger" :
        days <= 7 ? "primary" :
          days <= 15 ? "warning" :
            days <= 30 ? "info" :
              "success";

    return (
      <Tag
        severity={severity}
        value={`${days} días`}
        style={{
          fontSize: "11px",
          padding: "2px 6px",
          lineHeight: "1",
          minWidth: "auto"
        }}
      />
    );
  };



  return (
    <Fragment>
      <div className='container-global-zoom' >

        <Card>


          {!isSelectedClients && (
            <>
              <Col sm="12" className=' pb-2 pt-3' >
                <Row>
                  <Col sm="10">
                  </Col>
                  <Col sm="2">
                    <InputText
                      type="search"
                      placeholder="Buscar..."
                      onInput={(e) => setGlobalFilter(e.target.value)}
                      className="p-inputtext-sm"
                    />
                  </Col>
                </Row>


              </Col>

              <Col sm="12" className='pt-3'>
                <div className="table-responsive" >

                  <DataTable
                    className="data-table"
                    value={listClients}
                    expandedRows={expandedRows}
                    onRowToggle={(e) => setExpandedRows(e.data)}
                    rowExpansionTemplate={rowExpansionTemplate}
                    paginator
                    stripedRows
                    rows={10}
                    rowsPerPageOptions={[10, 30, 50, 90, 150]}
                    globalFilter={globalFilter}
                    responsiveLayout="scroll"


                  >
                    <Column
                      body={(rowData, { rowIndex }) => rowIndex + 1}
                      header="#"
                      headerStyle={{ ...headerStyle, textAlign: "center" }}
                      style={{ ...cellStyle, textAlign: "center" }}
                      sortable
                      field="id_company"
                    />
                    <Column
                      field="bussines_name"
                      header="Razón Social"
                      sortable
                      headerStyle={{ ...headerStyle, textAlign: "center" }}
                      style={{ ...cellStyle, textAlign: "center" }}
                    />
                    <Column
                      field="name"
                      header="Cliente"
                      sortable
                      headerStyle={{ ...headerStyle, textAlign: "center" }}
                      style={{ ...cellStyle, textAlign: "center" }}
                    />
                    <Column
                      field="rfc"
                      header="RFC"
                      sortable
                      headerStyle={{ ...headerStyle, textAlign: "center" }}
                      style={{ ...cellStyle, textAlign: "center" }}
                    />

                    <Column
                      field="credit_days"
                      header="Días de crédito"
                      body={renderCreditDays}
                      sortable
                      headerStyle={{ ...headerStyle, textAlign: "center" }}
                      style={{ ...cellStyle, textAlign: "center" }}
                    />






                    <Column
                      body={actionBodyTemplate}
                      header="Acción"
                      headerStyle={{ ...headerStyle, textAlign: "center" }}
                      style={{ ...cellStyle, textAlign: "center" }}
                    />
                  </DataTable>
                </div>

              </Col>

            </>
          )}

          {isSelectedClients && (
            <>
              <Col sm="12" md="12" lg="12">
                <Card style={{ textAlign: "left" }} className="height-equal pricingtable pt-0 pb-0 pr-0 pl-0">
                  <Col sm="12">
                    <Col sm="12" md="12" lg="12" className="text-right">
                      {/* <Button
                        color="dark"
                        className="m-2 rounded pb-1 pt-1 pl-1 pr-1"
                        style={{ fontSize: "12px" }}
                        onClick={() => {
                          setIsSelectedClients(false);
                          setSelectedInvoices([]);
                          setClientInformation(null);
                          setListInvoices([]);
                          setGlobalFilter(null)
                        }}
                        size="xs"
                      >
                        <span className="fa fa-filter"></span> Volver a los clientes
                      </Button> */}
                      <Button
                        color="dark"
                        className="m-2 rounded pb-1 pt-1 pl-1 pr-1"
                        style={{ fontSize: "12px" }}
                        size="xs"
                        onClick={() => {

                          // 👉 SI VIENE DE URL (tiene company)
                          if (idCompany) {
                            history.push(`../../../facturas/vencidas`);
                            return;
                          }

                          // 👉 SI NO VIENE company (flujo normal)
                          setIsSelectedClients(false);
                          setSelectedInvoices([]);
                          setClientInformation(null);
                          setListInvoices([]);
                          setGlobalFilter(null);
                        }}
                      >
                        <span className="fa fa-filter"></span> Volver a los clientes
                      </Button>
                    </Col>
                  </Col>
                  <CardBody className="pl-3 pr-3 pt-3 pb-3" >
                    <h6 className={idCompany === undefined ? "txt-info f-w-600" : "d-none"} >
                      {`${clientInformation?.bussines_name}`}
                      <br />
                      <label style={{ color: "#000000", fontSize: "12px" }} >RFC:  {`${clientInformation?.rfc}`}</label>
                    </h6> <br /> <br />

                    <h6 className={idCompany === undefined ? "d-none" : "txt-info f-w-600"} >

                      <label style={{ color: "#01479d", fontSize: "18px" }} >Cliente:  {`${clientInformation?.bussines_name}`}</label>
                      <br />
                      <label style={{ color: "#000000", fontSize: "12px" }} >RFC:  {`${clientInformation?.rfc}`}</label>
                    </h6>




                    <Row>
                      <Col sm="12" md="12" lg="12" className="text-right">
                        {selectedInvoices?.length > 0 && (
                          <div>
                            <Button
                              style={{
                                fontSize: "12px",
                                backgroundColor: "#D97706",
                                borderColor: "#ff9800",
                                color: "#fff"
                              }}
                              color="warning"
                              className="m-2 rounded pb-1 pt-1 pl-1 pr-1"
                              size="sm"
                              onClick={() => {
                                handleModal(true);
                                setLoadingComplement(true);
                                setIsPreComplement(false);
                                setTimeout(() => {
                                  setLoadingComplement(false);
                                }, 2000);
                              }}
                            >
                              {" "}
                              Complemento de pago
                            </Button>
                            <Button
                              style={{
                                fontSize: "12px",
                                backgroundColor: "#cad906",
                                borderColor: "#c8d42a",
                                color: "#fff"
                              }}
                              color="info"
                              className="m-2 rounded pb-1 pt-1 pl-1 pr-1"
                              size="sm"
                              onClick={() => {
                                handleModal(false);
                                setLoadingComplement(true);
                                setIsPreComplement(true);
                                setTimeout(() => {
                                  setLoadingComplement(false);
                                }, 2000);
                              }}
                            >
                              {" "}
                              Pre Complemento de pago
                            </Button>
                          </div>
                        )}
                      </Col>
                      <Col sm="12" md="12" lg="12">
                        <div className="table-responsive">
                          {listInvoices?.length === 0 && (
                            <div className="text-center">
                              <div
                                style={{ textAlign: "-webkit-center" }}
                                className="d-block"
                              >
                                `{" "}
                                <img
                                  className="img-fluid"
                                  src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                  style={{ width: "32%" }}
                                  alt=""
                                />
                              </div>
                              <p className="f-w-600 f-14 badge badge-light-primary">
                                No hay facturas pendientes por pagar
                              </p>
                            </div>
                          )}

                          {
                            listInvoices?.length > 0 && (<Table className="table-sm table-stripped" size="sm">
                              <thead className="theadInvoice">
                                <tr>
                                  <th
                                    className="text-center labeltheadInvoice"
                                    style={{
                                      padding: "5px 15px",
                                      textAlign: "center",
                                      position: "relative",
                                      borderTopLeftRadius: "10px",
                                    }}
                                  ></th>
                                  <th
                                    className="text-center labeltheadInvoice"
                                    style={{
                                      padding: "5px 15px",
                                      textAlign: "center",
                                      position: "relative",
                                    }}
                                  ></th>
                                  <th
                                    className="text-center labeltheadInvoice"
                                    style={{
                                      padding: "5px 15px",
                                      textAlign: "center",
                                      position: "relative",
                                    }}
                                  >
                                    SERIE/FOLIO
                                  </th>
                                  <th
                                    className="text-center labeltheadInvoice"
                                    style={{
                                      padding: "5px 15px",
                                      textAlign: "center",
                                      position: "relative",
                                    }}
                                  >
                                    FECHA
                                  </th>
                                  <th
                                    className="text-center labeltheadInvoice"
                                    style={{
                                      padding: "5px 15px",
                                      textAlign: "center",
                                      position: "relative",
                                    }}
                                  >
                                    MÉTODO DE PAGO
                                  </th>
                                  <th
                                    className="text-center labeltheadInvoice"
                                    style={{
                                      padding: "5px 15px",
                                      textAlign: "center",
                                      position: "relative",
                                    }}
                                  >
                                    PARCIALIDAD
                                  </th>
                                  <th
                                    className="text-center labeltheadInvoice"
                                    style={{
                                      padding: "5px 15px",
                                      textAlign: "center",
                                      position: "relative",
                                    }}
                                  >
                                    TOTAL
                                  </th>
                                  <th
                                    className="text-center labeltheadInvoice"
                                    style={{
                                      padding: "5px 15px",
                                      textAlign: "center",
                                      position: "relative",
                                    }}
                                  >
                                    DEV/DESCUENTOS
                                  </th>
                                  <th
                                    className="text-center labeltheadInvoice"
                                    style={{
                                      padding: "5px 15px",
                                      textAlign: "center",
                                      position: "relative",
                                    }}
                                  >
                                    MONTO PÁGADO
                                  </th>
                                  <th
                                    className="text-center labeltheadInvoice"
                                    style={{
                                      padding: "5px 15px",
                                      textAlign: "center",
                                      position: "relative",
                                    }}
                                  >
                                    SALDO
                                  </th>
                                  <th
                                    className="text-center labeltheadInvoice"
                                    style={{
                                      padding: "5px 15px",
                                      textAlign: "center",
                                      position: "relative",
                                      borderTopRightRadius: "10px",
                                    }}
                                  >
                                    UUID
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {listInvoices.map((invoice, index) => {

                                  return <tr
                                    key={`invoice-${invoice?.id_invoice}`}
                                    className="text-center f-w-600"
                                    style={{
                                      backgroundColor:
                                        idInvoice !== undefined &&
                                          Number(invoice?.id_invoice) === Number(idInvoice)
                                          ? '#3b82f64f'
                                          : 'transparent',
                                      transition: 'all 0.2s ease'
                                    }}
                                  >
                                    <td className="d-block">
                                      <Input
                                        type="checkbox"
                                        checked={
                                          selectedInvoices?.find(
                                            (inv) =>
                                              inv?.id_invoice ===
                                              invoice?.id_invoice
                                          ) ?? false
                                        }
                                        onChange={(e) =>
                                          handleCheckInvoice(
                                            e.target.checked,
                                            invoice
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      <img
                                        alt="flask"
                                        className="img-fluid text-info mr-2"
                                        src={require("../../assets/images/flask_laboratory.svg")}
                                        style={{ width: "30px", height: "30px" }}
                                      />
                                    </td>
                                    <td>{`${invoice?.serie ?? ""} ${invoice?.folio ?? ""
                                      }`}</td>
                                    <td>{invoice?.date ?? "-"}</td>
                                    <td>{invoice?.name_type_method ?? "-"}</td>
                                    <td>{invoice?.parciality_number ?? 1}</td>
                                    <td>
                                      $ {FormatAmount(invoice?.total ?? 0, 2)}
                                    </td>
                                    <td>
                                      $ {FormatAmount(invoice?.total_devolutions ?? 0, 2)}
                                    </td>
                                    <td>
                                      ${" "}
                                      {FormatAmount(
                                        invoice?.payment_amount ?? 0,
                                        2
                                      )}
                                    </td>
                                    <td>
                                      ${" "}
                                      {FormatAmount(
                                        invoice?.outside_balance ?? 0,
                                        2
                                      )}
                                    </td>
                                    <td>{invoice?.uuid}</td>
                                  </tr>;
                                })}
                              </tbody>
                            </Table>)
                          }
                        </div>
                      </Col>
                    </Row>
                    <br /><br /><br /><br />
                  </CardBody>
                </Card>
              </Col>
            </>
          )}
        </Card>

      </div>

      {showModal && (
        <ModalComplementPayment
          loadingPreview={loadingComplement}
          showPreviewInvoice={showModal}
          handlePreviewInvoice={handleModal}
          listInvoices={selectedInvoices}
          handleChangeType={handleChangeType}
          handleChangeAmount={handleChangeAmount}
          clientInformation={clientInformation}
          formComplement={formComplement}
          setFormComplement={setFormComplement}
          listPayForms={listPayForms}
          listCommercialLines={listCommercialLines}
          handleSaveComplement={handleSaveComplement}
          disbleButton={disableBtnSave}
          datECurrentTime={datECurrentTime}
          setDatECurrentTime={setDatECurrentTime}
          showPreview={showPreview}
          setShowPreview={setShowPreview}
          serie={listSettings}

        />
      )}
    </Fragment>
  );
};
